import React from 'react'

const CalenderSvg = ({ width, height }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 13.213 14.392'
    >
      <g id='calendar-simple-5-svgrepo-com' transform='translate(-5.83 -4.15)'>
        <g id='Group_972' data-name='Group 972'>
          <g id='b' transform='translate(6.18 4.5)'>
            <path
              id='Path_3165'
              data-name='Path 3165'
              d='M6.853,7.859a.674.674,0,0,0-.674.674V19.7a.674.674,0,0,0,.674.674H18.019a.674.674,0,0,0,.674-.674h0V8.533a.674.674,0,0,0-.674-.674Z'
              transform='translate(-6.179 -6.68)'
              fill='none'
              stroke='#000'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='0.7'
            />
            <line
              id='Line_155'
              data-name='Line 155'
              y1='2.022'
              transform='translate(2.33 0)'
              fill='none'
              stroke='#000'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='0.7'
            />
            <line
              id='Line_156'
              data-name='Line 156'
              y1='2.022'
              transform='translate(10.183 0)'
              fill='none'
              stroke='#000'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='0.7'
            />
          </g>
          <circle
            id='Ellipse_227'
            data-name='Ellipse 227'
            cx='0.586'
            cy='0.586'
            r='0.586'
            transform='translate(8.427 9.867)'
          />
          <circle
            id='Ellipse_228'
            data-name='Ellipse 228'
            cx='0.586'
            cy='0.586'
            r='0.586'
            transform='translate(11.851 9.867)'
          />
          <circle
            id='Ellipse_229'
            data-name='Ellipse 229'
            cx='0.586'
            cy='0.586'
            r='0.586'
            transform='translate(15.273 9.867)'
          />
          <circle
            id='Ellipse_230'
            data-name='Ellipse 230'
            cx='0.586'
            cy='0.586'
            r='0.586'
            transform='translate(8.427 13.826)'
          />
          <circle
            id='Ellipse_231'
            data-name='Ellipse 231'
            cx='0.586'
            cy='0.586'
            r='0.586'
            transform='translate(11.851 13.826)'
          />
          <circle
            id='Ellipse_232'
            data-name='Ellipse 232'
            cx='0.586'
            cy='0.586'
            r='0.586'
            transform='translate(15.273 13.826)'
          />
        </g>
      </g>
    </svg>
  )
}

export default CalenderSvg
